export const CHANGE_PASSWORD_FIELDS_NAMES = {
    CURRENT_PASSWORD: 'oldPassword',
    NEW_PASSWORD: 'newPassword',
    CONFIRM_NEW_PASSWORD: 'confirmNewPassword'
}